import Smart from './components/Smart';
import Robots from './components/Robots';
import Bounds from './components/Bounds';
import Mowing from './components/Mowing';
import Cut from './components/Cut';
import Character from './components/Character';
import Other from './components/Other';
import AimingPoint from './components/AimingPoint';
import Terms from './components/Terms';
import { Accessories } from '@/components/ProductCommon/accessories';
import { BundleList } from '@/components/ProductCommon/bundle-list';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import OtherList from '@/components/ProductCommon/OtherList';

const termsLocaleArr = ['us', 'ca', 'de', 'en', 'es', 'eu', 'fr', 'it', 'uk', 'au'];
export default function Com() {
    const { useRouter, gloproductlist } = useGlobal();
    const { locale } = useRouter();
    const isTermsLocale = termsLocaleArr.includes(locale as string);
    return (
        <>
            <Smart />

            <Robots />
            <Bounds />
            <Mowing />
            <Cut />
            <Character />
            <Other />
            {!!isTermsLocale && <Terms />}

            {!['au'].includes(locale) && <Accessories list={['blade-lsk', 'blade-seb']} />}
            {!['au'].includes(locale) && <BundleList list={['bladelsk', 'blade_seb_400psp', 'blade_lsk_seb_400psp']} moreUrl="/collections/smart" />}
            {['au'].includes(locale) && (
                <OtherList theme="black" data={getDetaileMoreProducts(gloproductlist, ['product_fridge_bx100', 'product_ac_kt210', 'product_sg_dg200'])} />
            )}
            <AimingPoint />
        </>
    );
}
